<template>
	<Confirmation v-if="type === ConfirmationType.ExtendDuration"
		:title="title" :button-options="buttonOptions"
		@agree="$emit('agree', durationToExtend, () => $emit('cancel'))" @cancel="$emit('cancel')">
		<v-card-text class="pa-4">
			<div class="px-2">
				<v-row class="align-center">
					<v-col cols="2">
						<label class="text-caption">Minutes:</label>
					</v-col>
					<v-col cols="2">
						<v-text-field type="number"
							v-model.number="durationToExtend" min="0" :max="customVariables.timeToExtend"
							:rules="[durationToExtendValidationRules.min, durationToExtendValidationRules.max]"
							variant="outlined" density="compact" hide-details/>
					</v-col>
					<v-col cols="1">
						<v-tooltip>
							<template v-slot:activator="{ props }">
								<v-icon v-bind="props" size="12" class="mr-2">
									mdi-information-outline
								</v-icon>
							</template>
							<span>The duration cannot be extended for longer than {{ customVariables.timeToExtend }} minutes.</span>
						</v-tooltip>
					</v-col>
				</v-row>
			</div>
		</v-card-text>
	</Confirmation>
	<GeneralConfirmation v-else :message="message"
		:button-options="buttonOptions" :styles="styles"
		@agree="$emit('agree')" @cancel="$emit('cancel')"/>
</template>
<script>
import Confirmation from "@/components/dialogs/Confirmation.vue";
import ConfirmationType from "@/enums/ConfirmationType";
import GeneralConfirmation from "@/components/dialogs/GeneralConfirmation.vue";

export default {
	name: "ExtendDurationConfirmation",
	components: {GeneralConfirmation, Confirmation},

	props: ["type", "title", "message", "buttonOptions", "customVariables", "styles"],

	emits: ["agree", "cancel"],

	data() {
		return {
			durationToExtend: 0,
			durationToExtendValidationRules: {
				min: v => v >= 0 || "Value must be greater or equal to 0",
				max: v => v <= this.customVariables.timeToExtend ||
						  `Value must be less or equal to ${this.customVariables.timeToExtend}`
			}
		}
	},

	computed: {
		ConfirmationType() {
			return ConfirmationType
		}
	}
}
</script>

<style lang="scss" scoped>
.confirmation-message {
	white-space: pre-wrap;
	justify-content: center;
	display: flex;
	flex-direction: column;
}

.v-card-actions {
	justify-content: end;
}
</style>